import {mergeConfig} from '../../configStore'
import {field} from '../field'
import type {SeoField, FieldReturn} from '../../types'

const defaultProps: Partial<SeoField> = {
  name: 'seo',
}

// TODO: Currently this is an alias to our `seo` field within each project.
// We should probably make this a custom field type that is defined here and
// remove the `seo` field from each project.
export const seo = (props?: SeoField, mergeProps?: Partial<SeoField>): FieldReturn =>
  field('seo', mergeConfig('seo', props, mergeProps, defaultProps))
